import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const formatPrice = (p, from = false) =>
  p ? `${from ? "À partir de " : ""}${new Intl.NumberFormat("fr-FR").format(p)} FCFA` : "Prix sur demande";

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const STATUS = {
  en_construction: { label: "En construction", cls: "bg-[#C88A58] text-white" },
  disponible: { label: "Disponible", cls: "bg-[#1F3A2B] text-white" },
  livre: { label: "Livré", cls: "bg-[#2F2A28] text-white" },
};

export const TYPES = { villa: "Villa", appartement: "Appartement", residence: "Résidence", terrain: "Terrain" };

export const LEAD_KINDS = { contact: "Information", visite: "Demande de visite", reservation: "Réservation" };

export const LEAD_STATUS = {
  nouveau: { label: "Nouveau", cls: "bg-[#C88A58]/15 text-[#9a5f30]" },
  contacte: { label: "Contacté", cls: "bg-[#2F2A28]/10 text-[#2F2A28]" },
  finalise: { label: "Finalisé", cls: "bg-[#1F3A2B]/15 text-[#1F3A2B]" },
};

export const CONTACT = {
  name: "Hélium Résidences",
  email: "heliumresidences@gmail.com",
  phone: "+221 77 848 18 61",
  tel: "+221778481861",
};

export const waLink = (msg = "Bonjour Hélium Résidences, je souhaite des informations.") =>
  `https://wa.me/221778481861?text=${encodeURIComponent(msg)}`;
